import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SEOHead from './components/SEOHead';
import ProductList from './components/ProductList';
import AdminPanel from './components/AdminPanel';
import AdminLogin from './components/AdminLogin';
import ProductForm from './components/ProductForm';
import AdminProductList from './components/AdminProductList';
import EditProduct from './components/EditProduct';
import UserForm from './components/UserForm';
import ProtectedRoute from './components/ProtectedRoute';
import EditProfile from './components/EditProfile';
import Cart from './components/Cart';
import { AuthProvider } from './components/AuthContext';
import { CartProvider } from './components/CartContext';
import AdminPurchases from './components/AdminPurchases';
import PurchaseDetail from './components/PurchaseDetail';
import ClientOrders from './components/ClientOrders';
import CustomerPurchaseDetail from './components/CustomerPurchaseDetail';
import OfferForm from './components/OfferForm';
import OfferList from './components/OfferList';
import EditOffer from './components/EditOffer';
import SuccessPage from "./components/SuccessPage";
import FailurePage from "./components/FailurePage";
import PendingPage from "./components/PendingPage";
import OfferNotificationManager from './components/OfferNotificationManager';
import { AdminPurchasesProvider } from './hooks/AdminPurchasesContext';
import FallingElements from "./components/FallingElements";
import ChatBot from './components/ChatBot';
import PermissionRoute from './components/PermissionRoute';
import EditEmployee from './components/EditEmployee';
import EmployeeList from './components/EmployeeList';
import AboutUs from './components/AboutUs';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import Contact from './components/Contact';
import CookieConsentBanner from './components/CookieConsentBanner';
import ClientList from './components/ClientList';
import EditClient from './components/EditClient';
import UploadProductExcel from './components/UploadProductExcel';
import DownloadProductCSV  from './components/DownloadProductCSV';
import ManageCategories from './components/ManageCategories';

function App() {
  return (
    <Router>
      <SEOHead 
        title="Sol y Luna - Tienda Online de Productos Exclusivos"
        description="Tienda online Sol y Luna. Compra productos exclusivos de sol y luna con envíos rápidos en Argentina. Ofrecemos accesorios, ropa y joyería de calidad."
        keywords="sol y luna, tienda online, comprar, productos, accesorios, ropa, joyería, Argentina"
      />
      <AuthProvider>
        <AdminPurchasesProvider>
          <CartProvider>
            <div className="App">
              <CookieConsentBanner />
              <Routes>
                <Route 
                  path="/" 
                  element={
                    <>
                      <FallingElements />
                      <ChatBot />
                      <ProductList />
                    </>
                  } 
                />
                <Route path="/cart" element={<Cart />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/success" element={<SuccessPage />} />
                <Route path="/failure" element={<FailurePage />} />
                <Route path="/pending" element={<PendingPage />} />

                {/* Rutas protegidas por rol */}
                <Route path="/admin/*" element={<ProtectedRoute element={<AdminPanel />} allowedRoles={['admin', 'employee']} />} />

                <Route path="/admin/create-user" element={<PermissionRoute element={<UserForm />} requiredRole="admin" />} />
                <Route path="/admin/employees" element={<PermissionRoute element={<EmployeeList />} requiredRole="admin" />} />
                <Route path="/admin/employees/edit/:id" element={<PermissionRoute element={<EditEmployee />} requiredRole="admin" />} />

                {/* Rutas protegidas por permisos */}
                <Route path="/admin/ProductForm" element={<PermissionRoute element={<ProductForm />} requiredPermission="createProduct" />} />
                <Route path="/admin/products" element={<PermissionRoute element={<AdminProductList />} requiredPermission="viewProducts" />} />
                <Route path="/admin/products/edit/:id" element={<PermissionRoute element={<EditProduct />} requiredPermission="editProduct" />} />
                <Route path="/admin/purchases" element={<PermissionRoute element={<AdminPurchases />} requiredPermission="viewPurchases" />} />
                <Route path="/purchase-details/:purchaseId" element={<PermissionRoute element={<PurchaseDetail />} requiredPermission="DetailsPurchases" />} />
                <Route path="/admin/OfferForm" element={<PermissionRoute element={<OfferForm />} requiredPermission="createOffer" />} />
                <Route path="/admin/offers" element={<PermissionRoute element={<OfferList />} requiredPermission="manageOffers" />} />
                <Route path="/admin/offers/edit/:id" element={<PermissionRoute element={<EditOffer />} requiredPermission="editOffer" />} />
                <Route path="/admin/offer-notifications" element={<PermissionRoute element={<OfferNotificationManager />} requiredPermission="viewOfferNotifications" />} />
                <Route path="/admin/clients" element={<PermissionRoute element={<ClientList />} requiredPermission="viewClients" />} />
                <Route path="/admin/clients/edit/:id" element={<PermissionRoute element={<EditClient  />} requiredPermission="editClients" />} />
                <Route path="/admin/UploadProductExcel" element={<PermissionRoute element={<UploadProductExcel  />} requiredPermission="UploadProductExcel" />} />
                <Route path="/admin/DownloadProductCSV" element={<PermissionRoute element={<DownloadProductCSV   />} requiredPermission="DownloadProductCSV" />} />
                <Route path="/admin/categories" element={<PermissionRoute element={<ManageCategories />} requiredRole="admin" />} />

                <Route path="/edit-profile" element={<EditProfile />} />
                <Route path="/client-orders" element={<ClientOrders />} />
                <Route path="/CustomerPurchaseDetail/:purchaseId" element={<CustomerPurchaseDetail />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsAndConditions />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </div>
          </CartProvider>
        </AdminPurchasesProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;









